import ProgressBarSelection from './assets/progress-bar-selection'
import ProgressBarRefund from './assets/progress-bar-refund'
import ProgressBarReturn from './assets/progress-bar-return'
import ProgressBarConfirm from './assets/progress-bar-confirm'
import { useTheme } from '@itsrever/design-system'
import { usePortalTranslate } from '@/hooks'
import { useContext } from 'react'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'

export interface ProgressBarProps {
  page:
    | 'order'
    | 'refund-method'
    | 'return-method'
    | 'confirm'
    | 'return-address'
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ page }) => {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)
  const theme = useTheme()

  return (
    <div className="z-10 flex flex-col content-center items-center">
      <div className="mt-2 grid min-w-[280px] grid-cols-4 grid-rows-2">
        <div data-testid="SVG" className="col-span-4 mb-1">
          {page === 'order' && <ProgressBarSelection />}
          {page === 'refund-method' && <ProgressBarRefund />}
          {page === 'return-address' && <ProgressBarReturn />}
          {page === 'return-method' && <ProgressBarReturn />}
          {page === 'confirm' && <ProgressBarConfirm />}
        </div>
        <p
          className="text-center text-[11px] leading-[16px]"
          dangerouslySetInnerHTML={{
            __html: translate('progress_bar_selection')
          }}
        />
        <p
          className="text-center text-[11px] leading-[16px]"
          style={{
            color:
              page === 'order'
                ? theme.colors.grey[2]
                : theme.colors.common.black
          }}
          dangerouslySetInnerHTML={{
            __html: translate('progress_bar_refund')
          }}
        />
        <p
          className="text-center text-[11px] leading-[16px]"
          style={{
            color:
              page === 'order' || page === 'refund-method'
                ? theme.colors.grey[2]
                : theme.colors.common.black
          }}
          dangerouslySetInnerHTML={{
            __html: translate('progress_bar_return')
          }}
        />
        <p
          className="text-center text-[11px] leading-[16px]"
          style={{
            color:
              page === 'order' ||
              page === 'refund-method' ||
              page === 'return-method'
                ? theme.colors.grey[2]
                : theme.colors.common.black
          }}
          dangerouslySetInnerHTML={{
            __html: translate('progress_bar_overview')
          }}
        />
      </div>
    </div>
  )
}

export default ProgressBar
